import React, { Component } from 'react';
import { observer, inject } from 'mobx-react'; 
import { withStyles } from '@material-ui/core/styles';
//import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import SuppliersIcon from '@material-ui/icons/EmojiTransportation';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


const styles = theme => ({
    paper: {
        flexGrow: 1, 
        padding: theme.spacing(2),
        display: 'flex',
        flexFlow: 'column',
      },
      icon: {
        fontSize: 100,
        color: '#607d8b',
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
      },
      leftCol:{
        textAlign: 'center',
      },
      rightCol: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexFlow: 'column',
        padding: theme.spacing(2)
      },
      input: {
          flexGrow: 1,
          marginTop: theme.spacing(2)
      },
      buttons: {
        marginTop: theme.spacing(8),
        flexGrow: 1,
        display: 'flex',
        flexFlow: 'row',
        justifyContent: 'space-between',
      }
});

class SuppliersDetails extends Component {
    state = {
        supplier: {},
        askDeldlgOpen: false,
    }

    handleSwitchAvailable = event => {
        let status = 'Active';
        if(event.target.checked===false){
            status = 'Inactive';
        } 
        this.props.appState.supplier.STATUS = status;
    }

    communicate = (qry, route) =>{
        this.props.appState.appRoutine.loading = true;

        fetch(this.props.appState.appRoutine.apiUrl + route, 
          {
          method: 'POST', // or 'PUT'
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(qry),
          })
          .then(res => res.json())
          .then(
            (result) => {
                this.props.appState.appRoutine.loading = false;
              if(result.status === 'err'){
                alert(result)
              };
              this.props.appState.appRoutine.msg = {
                text: 'Saved',
                open: true,
                type: 'success',
              }
              this.props.reload();
            },
            (error) => {
                this.props.appState.appRoutine.loading = false;
                alert(error)
            }
          )
    }

    handleUpdate = () => {
         const qry = this.props.appState.supplier;
         let route =  'suppliers/update';
         if(this.props.appState.supplier.ID === 0){
            route =  'suppliers/insert'
         }
         this.communicate(qry, route);
      }

    doDelete = () => {
        const qry = {
            'ID': this.props.appState.supplier.ID
        }
        const route = 'suppliers/delete';
        this.communicate(qry, route);
        this.props.appState.supplier = {};
    }

  render() {
    const {classes, appState} = this.props;
    

    return (
              <div>
                <Paper className={classes.paper}>
                    <Grid container className={classes.root} spacing={3}>
                        <Grid item xs={12} sm={12} md={4} className={classes.leftCol} >
                                <SuppliersIcon className={classes.icon}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={8} className={classes.rightCol}>
                            <TextField 
                                label="Name" 
                                variant="outlined" 
                                className={classes.input} 
                                value={appState.supplier.NAME} 
                                onChange={(event)=>{appState.supplier.NAME = event.target.value}}
                                />
                            <TextField label="Phone" 
                                variant="outlined" 
                                className={classes.input} 
                                value={appState.supplier.PHONE}
                                onChange={(event)=>{appState.supplier.PHONE = event.target.value}}
                                />
                            <TextField label="E-mail" 
                                variant="outlined" 
                                className={classes.input} 
                                value={appState.supplier.EMAIL}
                                onChange={(event)=>{appState.supplier.EMAIL = event.target.value}}
                                />
                            <TextField 
                                label="Address" 
                                variant="outlined" 
                                multiline rows='3' 
                                className={classes.input} 
                                value={appState.supplier.ADDRESS}
                                onChange={(event)=>{appState.supplier.ADDRESS = event.target.value}}
                                />
                            
                            <Grid container>
                                <Grid item xs={12} sm={12} md={6}  style={{display: 'flex'}}>
                                    <TextField 
                                        label="PCO" 
                                        variant="outlined" 
                                        className={classes.input} 
                                        value={appState.supplier.PCO}
                                        onChange={(event)=>{appState.supplier.PCO = event.target.value}}
                                        />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} >
                                    <FormControlLabel
                                        style={{padding: 8, marginLeft: 5}}
                                        className={classes.input}
                                        control={
                                        <Switch
                                            checked={appState.supplier.STATUS==='Active'? true : false}
                                            onChange={this.handleSwitchAvailable}
                                            value={appState.supplier.STATUS}
                                            color="primary"
                                        />
                                        }
                                        label="Active"
                                    />
                                </Grid>
                            </Grid>

                            <div className={classes.buttons}>
                                <IconButton color="primary" aria-label="Delete" style={{margin: 10}} component="span" onClick={()=>this.setState({askDeldlgOpen: true})}>
                                  <DeleteIcon />
                                </IconButton>
                                <Button variant="contained" color="primary" style={{margin: 10}} onClick={this.handleUpdate}>Update</Button>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>



                <Dialog
                    open={this.state.askDeldlgOpen}
                    onClose={()=>this.setState({askDeldlgOpen: false})}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Delete?"}</DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Please confirm you really want to delete.
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={()=>this.setState({askDeldlgOpen: false})} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.doDelete} color="primary" autoFocus>
                        Confirm
                    </Button>
                    </DialogActions>
                </Dialog>
              </div>
    );
  }
}



export default withStyles(styles)(inject('appState')(observer(SuppliersDetails)));